// extracted by mini-css-extract-plugin
export default {"container":"Mensaje_container__pW5cW","titulo":"Mensaje_titulo__HFib+","icon":"Mensaje_icon__dPc2M","texto":"Mensaje_texto__zmNuA"};